export default "__VITE_ASSET__CD9c2_MH__"